/*
 * @Author: 党方超
 * @Date: 2020-09-03 16:29:08
 * @LastEditTime: 2021-03-25 09:29:14
 * @LastEditors: Please set LastEditors
 * @Description: 上传到oss服务器
 * @FilePath: /dmps-console-web/src/utils/upload.js
 */
import axios from 'axios'
import file from '../api/file'
import help from './help'
const store = []

/**
 * @description: 上传到oss服务器
 * @param {String, FormData}
 * @return {type}
 */
const UploadOss = function(
  method,
  url,
  contentType,
  data,
  cancelToken,
  callback
) {
  delete axios.defaults.headers.common['Authorization']
  let formData = new FormData()
  formData.append('file', data)

  return axios({
    method,
    url,
    headers: {
      'Content-Type': contentType || 'application/octet-stream'
    },
    data,

    onUploadProgress: function(progressEvent) {
      if (progressEvent.lengthComputable && callback) {
        const precent = (progressEvent.loaded * 100) / progressEvent.total
        callback(precent)
      }
    },
    cancelToken: cancelToken
  })
    .then(res => {
      return res
    })
    .catch(err => {
      return err
    })
}

/**
 * @description: 上传到oss服务器
 * @param {String, FormData}
 * @return {type}
 */
const getIp = function() {
  return axios
    .get('https://api.myip.la/cn?json')
    .then(res => {
      return res
    })
    .catch(err => {
      return err
    })
}

/**
 * @description: 上传配置
 * @param {String, String}
 * @return {Promise}
 */
const getUploadConfig = async function(
  file,
  path,
  name = '',
  cancelToken,
  callback
) {
  let prefile = `${path}/`
  let type = file.name.split('.')
  prefile = prefile + (name || `${help.guid()}.${type[type.length - 1]}`)
  // const prefile = path + '/' + (file.webkitRelativePath || file.name)
  const { method, uploadPath, contentType } = await getSignature(prefile)

  store[prefile] = 0

  return Upload(
    prefile,
    file,
    method,
    uploadPath,
    contentType,
    cancelToken,
    e => {
      if (callback) {
        callback(e)
      }
    }
  )
}

const getSignature = async function(path) {
  return await file.signal(path)
}

const Upload = async function(
  prefile,
  formData,
  method,
  uploadPath,
  contentType,
  cancelToken,
  callback
) {
  return UploadOss(
    method,
    uploadPath,
    contentType,
    formData,
    cancelToken,
    e => {
      callback(e)
    }
  ).then(res => {
    if (res.status === 200 || res.status === 204) {
      delete store[prefile]
      return prefile
    } else {
      if (store[prefile] < 3) {
        store[prefile]++
        return Upload(
          prefile,
          formData,
          method,
          uploadPath,
          contentType,
          cancelToken,
          callback
        )
      } else {
        delete store[prefile]
        return 'err:' + prefile.split('/')[prefile.split('/').length - 1]
      }
    }
  })
}

export { UploadOss, getIp, getUploadConfig }
